export default __webpack_public_path__ + "static/media/kathrin.a956b010.png";